import { render, staticRenderFns } from "./ActionWithTitleAndSubtitle.vue?vue&type=template&id=449f31f0&"
import script from "./ActionWithTitleAndSubtitle.vue?vue&type=script&lang=js&"
export * from "./ActionWithTitleAndSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports